"use strict";

exports.__esModule = true;
/**
 * Truncates the result set based on `maxResults` and returns the new set.
 */
function getTruncatedOptions(options, maxResults) {
  if (!maxResults || maxResults >= options.length) {
    return options;
  }

  return options.slice(0, maxResults);
}

exports["default"] = getTruncatedOptions;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./~/ssc-refer/lib/refer/utils/getTruncatedOptions.js
// module id = 591
// module chunks = 0